/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：830
 */

var r = require(/* 714 */"../1648/714")
module.exports = Array.isArray || function (e) {
  return "Array" == r(e)
}
